const FILTER_TYPE = {DATE_RANGE: 'DATE_RANGE', DROPDOWN: 'DROPDOWN', SEARCH: 'SEARCH'};

export {FILTER_TYPE};
